<script>
  export default {
    name: 'CoinPackage',

    props: {
      item: {
        type: Object,
        required: true,
      },
      order: {
        type: Number,
        required: true,
      },
      highlighted: {
        type: Boolean,
        default: false,
      },
      toggle: {
        type: Function,
        default: () => {},
      },
    },

    computed: {
      ribbonText() {
        if (!this.item.MMC) {
          return 'EXCLUSIVE';
        }

        return `DAILY DEAL`;
      },

      imageUrl() {
        const { price, group, MMC, MQC } = this.item;

        if (group === 'Promo') {
          return `/images/cashier/promo-pack_price-${price}_MC-${MMC}_QC-${MQC}.webp?v=8`;
        }
        return `/images/cashier/regular-pack_price-${price}_MC-${MMC}_QC-${MQC}.webp?v=6`;
      },
    },

    methods: {
      selectPackage(slide) {
        this.$emit('selectPackage', slide);
      },

      togglePackage() {
        this.toggle?.();
        this.selectPackage(this.item);
      },
    },
  };
</script>

<template>
  <div
    :class="{ bordered: highlighted }"
    :data-ribbon-text="ribbonText"
    class="package-container cursor-pointer"
    @click="togglePackage"
  >
    <v-img
      :alt="`MQ cashier pack #${order}`"
      :aspect-ratio="46 / 27"
      :src="imageUrl"
      class="cashier-item"
      contain
      height="100%"
    />
  </div>
</template>

<style lang="scss" scoped>
  .mc-container {
    height: 24px;

    .title {
      line-height: 10px;
    }
  }

  .package-container {
    transition: all 0.25s;
    background: #f0f0f0;
    border-radius: 8px;
    position: relative;

    &.bordered {
      box-shadow: 0 0 0 3px #5b25c4;
      position: relative;
    }

    &:hover,
    &:active {
      transform: translateY(-4px);
    }

    .cashier-item {
      border-radius: 10px;
    }

    .row {
      padding: 20px 26px;
      transition: all 0.25s;

      .coins-img {
        position: absolute;
        top: -15px;
      }

      .bonus-mc {
        display: flex;
        align-items: center;
        width: max-content;
        gap: 4px;
        background: var(--v-gold-base);
        color: #2d2d2d;
        font-weight: 600;
        border-radius: 6px;
        padding: 3px 11px;
        font-size: 15px;
        border: 0.75px solid #2d2d2d;

        .v-icon {
          color: inherit;
          font-size: 16px;
        }
      }
    }

    .buy-btn {
      transition: all 0.25s;
      background: #0a9a49;
      width: 100%;
      border: 1px solid #2de27c;
      font-weight: 700;
      color: #2d2d2d;
      border-radius: 8px;
      margin-top: 40px;
      font-family: Inter, sans-serif !important;
    }
  }
</style>
